import { jsx } from "react/jsx-runtime";
import { IconButton } from "@mui/material";
import { useCallback } from "react";
import { useColorPicker } from "../../../hooks/useColorPicker.js";
import { NO_COLOR } from "../../../constants.js";
import { NoColorChip } from "../../Swatch/components/NoColorChip.js";
import { NoColorIcon } from "../../Swatch/components/NoColorIcon.js";
import { Tooltip } from "../../Tooltip.js";
function NoColorButton() {
  const { onChange, localeText } = useColorPicker();
  const onClick = useCallback(() => {
    onChange(null, NO_COLOR);
  }, [onChange]);
  return /* @__PURE__ */ jsx(Tooltip, { placement: "bottom", title: localeText.noColorLabel, "data-testid": "TidalColorPickerNoColorButton", children: /* @__PURE__ */ jsx(IconButton, { component: "span", onClick, children: /* @__PURE__ */ jsx(NoColorChip, { component: "span", size: 24, children: /* @__PURE__ */ jsx(NoColorIcon, {}) }) }) });
}
export {
  NoColorButton
};
//# sourceMappingURL=NoColorButton.js.map
